declare var contactForm: ContactFormConfig;

export function initContactForm(): void {
    // Wait for WordPress to initialize the contactForm object
    const waitForContactForm = () => {
        if (typeof window.contactForm === 'undefined') {
            setTimeout(waitForContactForm, 100);
            return;
        }
        initializeFormHandlers();
    };

    const initializeFormHandlers = () => {
        const forms = document.querySelectorAll('.fetch-form') as NodeListOf<HTMLFormElement>;
        
        forms.forEach(form => {
            form.addEventListener('submit', async function(e: Event) {
                e.preventDefault();
                
                // Disable form buttons
                const buttons = form.querySelectorAll('button');
                buttons.forEach(button => button.setAttribute('disabled', 'disabled'));
                
                // Remove any existing error messages
                const existingError = document.getElementById('contact-form-error');
                if (existingError) {
                    existingError.remove();
                }
                
                try {
                    const formData = new FormData(this);
                    formData.append('action', 'handle_contact_form');
                    formData.append('contact_form_nonce', window.contactForm.nonce);
                    
                    const response = await fetch(window.contactForm.ajaxUrl, {
                        method: 'POST',
                        body: formData
                    });
                    
                    if (!response.ok) {
                        throw new Error(`HTTP error! status: ${response.status}`);
                    }
                    
                    const result = await response.json() as ContactFormResponse;
                    
                    if (result.success) {
                        // Hide the form
                        form.style.display = 'none';
                        
                        // Show success message
                        const successDiv = document.createElement('div');
                        successDiv.className = 'p-4 text-base border-2 border-green-800 text-green-800 rounded-lg bg-green-50 dark:bg-gray-800 dark:text-green-400';
                        successDiv.textContent = 'Thank you, your enquiry has been submitted successfully.';
                        form.parentNode?.insertBefore(successDiv, form.nextSibling);
                    } else {
                        throw new Error(result.data || 'Unknown error occurred');
                    }
                } catch (error) {
                    const errorDiv = document.createElement('div');
                    errorDiv.id = 'contact-form-error';
                    errorDiv.className = 'p-4 mt-4 text-base border-2 border-red-800 text-red-800 rounded-lg bg-red-50 dark:bg-gray-800 dark:text-red-400';
                    errorDiv.textContent = error instanceof Error ? error.message : 'An error occurred while submitting your enquiry. Please try again.';
                    form.parentNode?.insertBefore(errorDiv, form.nextSibling);
                    
                    // Re-enable buttons
                    buttons.forEach(button => button.removeAttribute('disabled'));
                }
            });
        });
    };

    // Start waiting for contactForm
    waitForContactForm();
}
